import { SEPARATOR_POSITIONS } from './config'

const countSeparators = (position: number) => {
  return SEPARATOR_POSITIONS.reduce(
    (accumulator, separatorPosition) =>
      position >= separatorPosition ? accumulator + 1 : accumulator,
    0
  )
}

const getTrueCursorPosition = (position: number) => {
  return position - countSeparators(position)
}

const getModifiedCursorPosition = (position: number) => {
  return position + countSeparators(position)
}

export { getTrueCursorPosition, getModifiedCursorPosition }
